// client/src/App.js
import React, { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Login from "./components/Login"; // Adjust the import path if necessary
import Invoices from "./components/Invoices"; // Adjust the import path if necessary
import ProtectedRoute from "./ProtectedRoute";
import axios from "axios";
import Products from "./components/Products"; // Adjust the path as necessary
import MenuBar from "./components/MenuBar";
import ProductDetail from "./components/ProductDetail";
import CustomerDashboard from "./components/CustomerDashboard"; // Make sure the path is correct
import Logout from "./components/Logout"; // Make sure the path is correct
import Gifts from "./components/Gifts"; // Import the Gifts component
import EmployeeLogin from "./components/EmployeeLogin";
import CustomerSchemes from "./components/CustomerSchemes";
import ContactUs from "./components/ContactUs";
import ComplaintForm from "./components/ComplaintForm";
import Orders from "./components/Orders";
import EmployeeDashboard from "./components/EmployeeDashboard";
import Reports from "./components/Reports";
import NotOrderedThisMonth from "./components/NotOrderedThisMonth";
import NotOrderedTwoMonths from "./components/NotOrderedTwoMonths";
import LessOrderedThisMonth from "./components/LessOrderedThisMonth";
import MissingYearlyTargets from "./components/MissingYearlyTargets";
import MissingMonthlyTargets from "./components/MissingMonthlyTargets";
import AreaSearch from "./components/AreaSearch";
import DispatchPage from "./components/DispatchPage";
import OrderEntries from "./components/OrderEntries";
import PrintLabelPage from "./components/PrintLabelPage";
import OrderStatus from "./components/OrderStatus";
import CustomerDispatches from "./components/CustomerDispatches";
import GiftEntries from "./components/GiftEntries";
import mixpanel from "mixpanel-browser";
import CaseSizes from "./components/CaseSizes";
import IpWhitelistPage from "./components/IpWhitelistPage";
import ItemWiseReports from "./components/ItemWiseReports";
import MyAllParties from "./components/MyAllParties";
import ReminderCards from "./components/ReminderCards";
import ImageReminderCards from "./components/ImageReminderCards";
import QueryManagementSystem from "./components/QueryManagementSystem";
import OrderGifts from "./components/OrderGifts";
import Home from "./components/Home";
import PartyAssociates from "./components/PartyAssociates";
import "@n8n/chat/style.css"; // Import n8n chat widget styles
import { createChat } from "@n8n/chat"; // Import the n8n chat widget function

mixpanel.init("c806a56198658f2f6bdf04390293fdfb", { debug: true });

axios.defaults.withCredentials = true;

function App() {
  const { isLoggedIn, login, logout, userType } = useAuth();
  console.log("API URL:", process.env.REACT_APP_API_URL);
  const [sessionChecked, setSessionChecked] = useState(false);

  // useEffect(() => {
  //   axios.get('http://localhost:3001/check-session')
  //     .then(response => {
  //       if (response.data.isLoggedIn && response.data.user.mobile) {
  //         login(response.data.user.mobile); // Update login state based on session status
  //       }
  //     })
  //     .catch(error => {
  //       console.error('Session check failed:', error);
  //     });
  // }, [login]);

  mixpanel.track("Page View", {
    page: window.location.pathname,
  });

  // useEffect(() => {
  //   createChat({
  //     webhookUrl:
  //       "https://n8n.trumachealthcare.net/webhook/5778caf9-2657-445d-a92d-6b6808a17c48/chat", // Replace with your actual n8n webhook URL
  //     initialMessages: [
  //       "Hello! 👋 How can I help you today?", // Set a custom initial message when the chat starts
  //     ],
  //     i18n: {
  //       en: {
  //         title: "Trumac Chatbot",
  //         subtitle: "I am here to assist you with your pharma product queries.",
  //         getStarted: "New Conversation",
  //         inputPlaceholder: "Type your question..",
  //       },
  //     },
  //     theme: {
  //       primaryColor: "#007bff", // Matches the Bootstrap primary blue from menu-bar
  //       textColor: "#ffffff", // Set the text color to white for contrast
  //       backgroundColor: "#0056b3", // Use the darker hover blue as the background color
  //       hoverColor: "#cce5ff", // Lighter blue for hover effect
  //       activeLinkColor: "#ffd700", // Gold color for active state, matching the active link in the menu-bar
  //       buttonBackgroundColor: "#007bff", // Matches the menu bar button color
  //       buttonTextColor: "#ffffff", // White text on buttons
  //     },
  //   });
  // }, []);

  useEffect(() => {
    // Load the gtag.js script
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-16693317711";
    script.async = true;
    document.body.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "AW-16693317711");
  }, []);

  useEffect(() => {
    // Add the conversion tracking script dynamically
    const script = document.createElement("script");
    script.innerHTML = `
      function gtag_report_conversion(url) {
        var callback = function () {
          if (typeof(url) != 'undefined') {
            window.location = url;
          }
        };
        gtag('event', 'conversion', {
          'send_to': 'AW-16693317711/JxrdCIHcutAZEM-g_5c-',
          'value': 1.0,
          'currency': 'INR',
          'event_callback': callback
        });
        return false;
      }
    `;
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      console.log(`Called : Islooged in : ${isLoggedIn}`);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/check-session`
        );
        if (
          response.data.isLoggedIn &&
          (response.data.user.mobile || response.data.user.mobileNumber)
        ) {
          login(
            response.data.user.mobile
              ? response.data.user.mobile
              : response.data.user.mobileNumber,
            response.data.user.employee_id ? "employee" : "customer"
          ); // Here make sure to login only if not already logged in
        } else if (isLoggedIn) {
          logout(); // Here make sure to logout only if not already logged out
        }
      } catch (error) {
        console.error("Session check failed:", error);
      } finally {
        setSessionChecked(true); // Ensure this is set regardless of outcome
      }
    };

    // Call checkSession if not already logged in
    if (!isLoggedIn) {
      checkSession();
    }
  }, [isLoggedIn, login, logout]);

  if (!sessionChecked) {
    // Optional: Render a loading indicator while the session check is in progress
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <MenuBar />
      <Routes>
        <Route
          path="/"
          // element={
          //   <Navigate replace to={isLoggedIn ? "/invoices" : "/login"} />
          // }
          element={<Products />}
        />
        <Route path="/products/:productId" element={<ProductDetail />} />
        <Route
          path="/login"
          element={
            isLoggedIn ? (
              <Navigate replace to="/customer-dashboard" />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/customer-dashboard"
          element={
            <ProtectedRoute allowedUserTypes={["customer"]}>
              <CustomerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-order-status"
          element={
            <ProtectedRoute allowedUserTypes={["customer"]}>
              <OrderStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-dispatch-status"
          element={
            <ProtectedRoute allowedUserTypes={["customer"]}>
              <CustomerDispatches />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <EmployeeDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <EmployeeDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/case-sizes"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <CaseSizes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/party-associates"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <PartyAssociates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/area-search"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <AreaSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gift-entries"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <GiftEntries />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dispatch"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <DispatchPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-entries"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <OrderEntries />
            </ProtectedRoute>
          }
        />
        <Route
          path="/qms"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <QueryManagementSystem />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-gifts"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <OrderGifts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/print-label-page"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <PrintLabelPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/not-ordered-this-month"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <NotOrderedThisMonth />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/my-all-parties"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <MyAllParties />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/item-wise-reports"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <ItemWiseReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/not-ordered-two-months"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <NotOrderedTwoMonths />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/less-ordered-this-month"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <LessOrderedThisMonth />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/missing-yearly-targets"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <MissingYearlyTargets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/missing-monthly-targets"
          element={
            <ProtectedRoute allowedUserTypes={["employee"]}>
              <MissingMonthlyTargets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices"
          element={
            <ProtectedRoute allowedUserTypes={["customer"]}>
              <Invoices />
            </ProtectedRoute>
          }
        />
        <Route path="/logout" element={<Logout />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/pcd-pharma-franchise" element={<Home />} />
        <Route path="/reminder-cards" element={<ReminderCards />} />
        <Route path="/image-reminder-cards" element={<ImageReminderCards />} />
        <Route path="/employee-login" element={<EmployeeLogin />} />
        <Route
          path="/complaint-form"
          element={
            <ProtectedRoute allowedUserTypes={["customer"]}>
              <ComplaintForm />
            </ProtectedRoute>
          }
        />
        <Route path="/gifts" element={<Gifts />} />{" "}
        <Route path="/ip-whitelist" element={<IpWhitelistPage />} />{" "}
        <Route
          path="/customer-schemes"
          element={
            <ProtectedRoute allowedUserTypes={["customer"]}>
              <CustomerSchemes />
            </ProtectedRoute>
          }
        />
        {/* Add this route for the Gifts component */}
        <Route
          path="*"
          element={
            <Navigate
              replace
              to={
                isLoggedIn
                  ? userType === "customer"
                    ? "/customer-dashboard"
                    : "/employee-dashboard"
                  : "/login"
              }
            />
          }
        />
      </Routes>
    </Router>
  );
}

const AppWrapper = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

export default AppWrapper;
